import {
    APPSTORE_LINK_DESC,
} from "src/constants/ServiceConstants";
import '../styles/overlay.scss';
import {Badge} from "src/components/Badge";
import React from "react";

export const Overlay = () => {
    return (
        <div className="container">
            <div className="connection-status">
                <div className="status">
                    Under Maintenance
                </div>
            </div>
            {(() => {
                return (
                    <>
                        <div className="status-desc">
                            <p>This page is currently down for scheduled maintenance. Please check back later.</p>
                        </div>
                        <div className="banner-container">
                            <p className="appstore-link">
                                {APPSTORE_LINK_DESC}
                            </p>
                        </div>
                        <div className="badge-container">
                            <Badge/>
                        </div>
                    </>
                );
            })()}
        </div>
    )
}
